// Modules
import React, { Component } from 'react';

// Styles
import './Calendar.scss'

// Interfaces
import {Tip} from 'Interfaces/TipInterface';

// Components
import Week from '../Week';

interface IProps {
    month:number;
    year:number;
    enabledDates: (string | Date)[];
    onDayClick(date:Date):void;
    activeDate: Date | null;
    dayTooltips?: {[index: string]: Tip[]};
    isDateOutsideWindow(date: Date): boolean;
    hasLoadError: boolean;
}

const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

class Calendar extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.getDaysInMonth = this.getDaysInMonth.bind(this);
    }

    getDaysInMonth():Date[] {
        var date = new Date(this.props.year, this.props.month, 1);
        var days = [];
        while (date.getMonth() === this.props.month) {
          days.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
        return days;
    }


    getWeeks():Date[][] {
        let days = this.getDaysInMonth();
        let weeks:Date[][] = [];
        let weekDays:Date[] = [];
        days.forEach((day:Date, index:number) => {
             weekDays.push(day);
             if (day.getDay() == 6 || index == days.length -1) {
                 weeks.push(weekDays);
                 weekDays = [];
             }
        })

        return weeks;
    }

    getDateStamp(date:Date) {
        return (`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`)
    }

    render() {
        return (
            <div className="calendar">

                <table>
                    <tbody>
                    <tr>
                        {dayNames.map((day:string) =>
                            <th key={day}><div className="day-heading">{day}</div></th>
                        )}
                    </tr>
                    {this.getWeeks().map((week:Date[]) =>
                        <Week
                          key={"week-" + this.getDateStamp(week[0])}
                          weekDays={week}
                          enabledDates={this.props.enabledDates}
                          onDayClick={this.props.onDayClick}
                          activeDate={this.props.activeDate}
                          dayTooltips={this.props.dayTooltips}
                          isDateOutsideWindow={this.props.isDateOutsideWindow}
                          hasLoadError={this.props.hasLoadError}
                        />
                    )}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Calendar;
